"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M8.252 24h7.496C19.08 24 20 22.787 20 21.528c0-1.773-4.91-4.059-4.91-5.668 0-2.939 3.266-4.175 3.266-8.63C18.4 3.242 15.638 0 12.241 0h-.482C8.384 0 5.622 3.242 5.622 7.254c0 4.478 3.266 5.69 3.266 8.63C8.91 17.492 4 19.754 4 21.55 4 22.787 4.942 24 8.252 24z" }), "EpicAccount");
//# sourceMappingURL=EpicAccount.js.map